import { useMutation, useQueryClient } from "@tanstack/react-query";
import locationBulkCSVExportService from "../../../services/locations/bulkCSVExportService";

export const useCreateBulkCSVExport = (mutationOptions = {}) => {
  const queryClient = useQueryClient();
  return useMutation(
    (locationIDs) =>
      locationBulkCSVExportService.create({
        locationIDs: locationIDs ?? "All",
      }),
    {
      ...mutationOptions,
      onSuccess: (data) => {
        queryClient.invalidateQueries("locations");
        mutationOptions.onSuccess && mutationOptions.onSuccess(data);
      },
    }
  );
};
